/**
 * This function is exported as default. It initializes the functionality for handling tabs.
 */
export default () => {
	// Find all tab panels on the page
	const tabPanels = document.querySelectorAll('.govuk-tabs__panel');

	// Check if there are tab panels found
	if (tabPanels.length > 0) {
		// Hide all tab panels except the first one
		tabPanels.forEach(function (panel, index) {
			if (index !== 0) {
				panel.classList.add('govuk-tabs__panel--hidden');
			}
		});

		// Show the initial tab panel
		const initialTab = document.querySelector('.govuk-tabs__tab');
		const initialPanelId =
			'panel-' + initialTab.getAttribute('id').split('-')[1];
		initialTab.classList.remove('govuk-tabs__panel--hidden');
		document
			.getElementById(initialPanelId)
			.classList.remove('govuk-tabs__panel--hidden');

		// Find all tab elements
		const tabs = document.querySelectorAll('.govuk-tabs__tab');

		// Add event listener to each tab
		tabs.forEach(function (tab) {
			tab.addEventListener('click', function (event) {
				event.preventDefault();
				// Get the ID of the clicked tab
				const tabId = this.getAttribute('id');
				// Generate the corresponding panel ID
				const panelId = 'panel-' + tabId.split('-')[1];

				// Hide all tab panels
				document
					.querySelectorAll('.govuk-tabs__panel')
					.forEach(function (panel) {
						panel.classList.add('govuk-tabs__panel--hidden');
					});

				// Show the corresponding panel for the clicked tab
				document
					.getElementById(panelId)
					.classList.remove('govuk-tabs__panel--hidden');
			});
		});
	}
};
